import { Button, cn, IconButton } from '@c2fo/liquidity';
import { CommentsQuestionDuotoneIcon } from '@c2fo/liquidity/icons';
import IntercomDataTarget from '@/reporting/IntercomDataTarget';

export interface ChatFooterProps {
  chatText: string;
  isCollapsed: boolean;
  isSubNavOpen: boolean;
  onClick: () => void;
}

const ChatFooter = ({ chatText, isCollapsed, isSubNavOpen, onClick }: ChatFooterProps) => {
  const baseProps = {
    onClick,
    variant: 'primary' as const,
  };
  const isSkinnyPrimaryNav = isCollapsed || isSubNavOpen;

  return (
    <IntercomDataTarget className="relative h-20" target="sideNavChat">
      <Button
        className={cn('absolute left-1/2 top-1/2 w-[85%] -translate-x-1/2 -translate-y-1/2', {
          'top-[150%]': isSkinnyPrimaryNav,
        })}
        icon={<CommentsQuestionDuotoneIcon className="fill-white" />}
        tabIndex={isSkinnyPrimaryNav ? -1 : 0}
        {...baseProps}
      >
        {chatText}
      </Button>
      <IconButton
        className={cn('absolute left-2 top-[150%] h-10 w-10 -translate-y-1/2', {
          'top-1/2': isSkinnyPrimaryNav,
        })}
        icon={CommentsQuestionDuotoneIcon}
        name="chat"
        tabIndex={isSubNavOpen ? -1 : isCollapsed ? 0 : -1}
        {...baseProps}
      />
    </IntercomDataTarget>
  );
};

export default ChatFooter;
